import { render, staticRenderFns } from "./CheckoutModalConfirmOrderContent.vue?vue&type=template&id=815969a8&scoped=true"
import script from "./CheckoutModalConfirmOrderContent.vue?vue&type=script&lang=js"
export * from "./CheckoutModalConfirmOrderContent.vue?vue&type=script&lang=js"
import style0 from "./CheckoutModalConfirmOrderContent.vue?vue&type=style&index=0&id=815969a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815969a8",
  null
  
)

export default component.exports